import React, { Component } from 'react';
import Merger from './../../../Core/Merger';
import Fields from './../../QueryBuilder/Fields';
import jQuery from 'jquery';

class Export extends Component {
  constructor(props) {
    super(props);

    (this.columns = []), (this.nodes = []);
    this.handleInput = this.handleInput.bind(this);
    this.submit = this.submit.bind(this);
  }

  handleInput(event) {
    var array = [...this.columns];
    var index = array.indexOf(event.target.name);
    if (index !== -1) {
      array.splice(index, 1);
    } else if (!event.target.name.includes('Opinion.')) {
      //Problème de clé étrangère avec les avis
      array.push(event.target.name);
    }
    this.columns = array;
  }

  submit() {
    var columns = [...this.columns];
    columns.sort();
    let select = '';
    columns.forEach((column) => {
      select += column + ', '; //Possiblement une virgule en trop
    });
    select = select.slice(0, -2);
    if (select !== '') {
      this.props.exportCSV(select);
    }
  }

  checkAll(e, name) {
    let checked = e.target.checked;
    this.nodes[name].querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
      checkbox.checked = checked;
      e.target.name = checkbox.name;
      this.handleInput(e);
    });
  }

  render() {
    return (
      <div
        className='modal fade'
        id='exportModal'
        tabIndex='-1'
        role='dialog'
        aria-hidden='true'
        aria-labelledby='#exportModaltTitle'
      >
        <div className='modal-dialog modal-dialog-scrollable modal-xl' role='document'>
          <div className='modal-content'>
            <div className='modal-header py-1'>
              <h4 className='modal-title text-uppercase ' id='exportModaltTitle'>
                Exporter la recherche
              </h4>
              <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              {Object.keys(Fields).map((key, index) => {
                return (
                  <div key={key}>
                    <span className='mx-2 my-2 row py-1 bg-light border-bottom'>
                      <span className='mt-1 h5'>{Fields[key].label} </span>
                      <div className='ml-auto mt-1 mr-2'>
                        <label className='mr-2' htmlFor={'all-form-check-' + key}>
                          Tous
                        </label>
                        <input
                          className='align-middle'
                          type='checkbox'
                          id={'all-form-check-' + key}
                          onChange={(e) => this.checkAll(e, key)}
                        />
                      </div>
                    </span>

                    <div
                      className='row justify-content-start pl-4'
                      ref={(ref) => {
                        this.nodes[key] = ref;
                        return true;
                      }}
                    >
                      {Object.keys(Fields[key].subfields).map((subKey, subIndex) => {
                        return (
                          <div className='col-4 form-group form-check' key={'form-check-' + key + '-' + subKey}>
                            <input
                              type='checkbox'
                              className='form-check-input'
                              name={key + '.' + subKey}
                              key={'radio-' + key + '-' + subKey}
                              onChange={(e) => this.handleInput(e)}
                            ></input>
                            <label className='form-check-label text-nowrap' htmlFor={'radio-' + key + '-' + subKey}>
                              {Fields[key].subfields[subKey].label}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className='modal-footer'>
              <button type='button' className='btn btn-primary text-center mx-auto' onClick={this.submit}>
                Lancer l'export
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Export;



// WEBPACK FOOTER //
// ./src/Components/Views/Export/Export.js